import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ItemizedList } from "../../../../components/header-reflection";
import { ReflectionType } from "../../../../../../../types/domain-types";

interface ItemizedAverageScoreData {
  questionTitle: string;
  averageScore: number;
}

interface UseItemizedListParams {
  itemizedAverageScoreData: ItemizedAverageScoreData[];
  reflectionType: ReflectionType | undefined;
}

export function useItemizedList({
  itemizedAverageScoreData,
  reflectionType,
}: UseItemizedListParams): ItemizedList | undefined {
  const { t } = useTranslation();

  return useMemo<ItemizedList | undefined>(() => {
    if (!itemizedAverageScoreData.length) {
      return undefined;
    }

    const isChallengeType = reflectionType === ReflectionType.Challenge;
    const title = isChallengeType
      ? t(
          "frontend.test.reflectionHeader.items.challenge",
          "Challenge Header Items"
        )
      : t(
          "frontend.test.reflectionHeader.items.leverage",
          "Leverage Header Items"
        );

    const items = itemizedAverageScoreData
      .map(item => ({
        title: item.questionTitle,
        score: item.averageScore,
      }))
      .sort((a, b) =>
        isChallengeType ? a.score - b.score : b.score - a.score
      );

    return { title, items };
  }, [itemizedAverageScoreData, reflectionType, t]);
}
